import { useEffect } from 'react'

// iOS can only receive notifications from an installed PWA, so iPhone users
// get this guide instead of a permission prompt.
export default function InstallGuideModal({ onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose()
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div className="guide-overlay" onClick={onClose}>
      <div className="guide-card" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <h3>Receber notificações no iPhone</h3>
        <p>Para seguir a equipa, instale primeiro a app no ecrã principal:</p>
        <ol>
          <li>Toque em <b>Partilhar</b> <span aria-hidden>⎋</span> na barra do Safari</li>
          <li>Escolha <b>"Adicionar ao ecrã principal"</b></li>
          <li>Abra a app <b>Cabreiros Cup</b> e volte a tocar em <b>Seguir equipa</b></li>
        </ol>
        <button className="follow-btn" onClick={onClose}>Entendi</button>
      </div>
    </div>
  )
}
